import { render, staticRenderFns } from "./subsector.vue?vue&type=template&id=4b764bd2&scoped=true"
import script from "./subsector.vue?vue&type=script&lang=js"
export * from "./subsector.vue?vue&type=script&lang=js"
import style0 from "./subsector.vue?vue&type=style&index=0&id=4b764bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b764bd2",
  null
  
)

export default component.exports